import type { AttributeSelection, ProductAttributeType } from '#types/product'
import type { Product, ProductVariants } from '~/api/clients/product/data-contracts'

export function getProductAvailability(
  attributeSelection: AttributeSelection,
  details: Ref<Product | null>
) {
  const getAllVariantsNotifyMe = (variants: ProductVariants) => variants.every(({ notifyMe }) => notifyMe)

  const filterOtherAttributes = (attributeType: ProductAttributeType) => details.value?.attributes
    .filter((attribute) => !['color', 'fitType', attributeType].includes(attribute.type))
    .map((attribute) => attribute.type)

  const areAllAttributesSelected = (attributeTypes: ProductAttributeType[]) =>
    attributeTypes.every((type) => attributeSelection[type])

  const findMatchingVariant = (attributeTypes: ProductAttributeType[], type: ProductAttributeType, value: string) =>
    details.value?.variants.find((variant) =>
      attributeTypes.every((attributeType) =>
        variant.attributes[attributeType] === attributeSelection[attributeType])
      && variant.attributes[type] === value)

  const getAttrOptionAvailable = (type: ProductAttributeType, value: string) => {
    const productAttributes = filterOtherAttributes(type) || []
    if (!productAttributes.length || !areAllAttributesSelected(productAttributes)) return true
    const variant = findMatchingVariant(productAttributes, type, value)
    return variant?.productInventoryState === 'InStock'
  }

  const getAttrOptionNotifyMe = (type: ProductAttributeType, value: string) => {
    const productAttributes = filterOtherAttributes(type) || []
    if (!productAttributes.length) {
      const variant = details.value?.variants.find((v) => v.attributes[type] === value)
      return variant?.notifyMe ?? false
    }
    if (!areAllAttributesSelected(productAttributes))
      return details.value?.variants ? getAllVariantsNotifyMe(details.value.variants) : false

    const variant = findMatchingVariant(productAttributes, type, value)
    return variant?.notifyMe ?? false
  }

  return {
    getAttrOptionAvailable,
    getAttrOptionNotifyMe
  }
}
